import { call, put, takeLatest, } from 'redux-saga/effects';
import { Urls } from 'src/common/urls';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { getErrorFromResponse } from 'src/features/Security/networking/util';
import { CustomerRecordsFilters } from 'src/common/models/customer';

const buildQueryString = (filters?: CustomerRecordsFilters) => {
    const filtersList: string[] = []
    if (filters?.isActive !== undefined) {
        filtersList.push(`active=${filters.isActive}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getCustomersApi(action: Actions.getCustomersAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.CUSTOMER.GET_RECORDS(buildQueryString(action.filters)))
        yield put(Actions.getCustomersApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getCustomersApiError(getErrorFromResponse(err)));
    }
}

function* createCustomerApi(action: Actions.UpsertCustomerAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.CUSTOMER.CREATE, action.customer)
        yield put(Actions.upsertCustomerApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.upsertCustomerError(getErrorFromResponse(err)));
    }
}

function* getCustomerByIdApi(action: Actions.GetCustomerByIdAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.CUSTOMER.GET_BY_ID(action.id))
        yield put(Actions.getCustomerByIdApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getCustomerByIdError(getErrorFromResponse(err)));
    }
}

function* sendAccountBalanceApi(action: Actions.SendAccountBalanceAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.CUSTOMER.SEND_ACCOUNT_BALANCE, action.payload)
        yield put(Actions.sendAccountBalanceApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.sendAccountBalanceError(getErrorFromResponse(err)));
    }
}

export default function* customerSagas() {
    yield takeLatest(ActionTypes.GET_CUSTOMERS_API, getCustomersApi)
    yield takeLatest(ActionTypes.UPSERT_CUSTOMER_API, createCustomerApi)
    yield takeLatest(ActionTypes.GET_CUSTOMER_BY_ID_API, getCustomerByIdApi)
    yield takeLatest(ActionTypes.SEND_ACCOUNT_BALANCE_API, sendAccountBalanceApi)
}
